//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React, { useState } from 'react';

import { SecondaryButtonStyles } from '@components/atoms/button/buttonStyles';
import { Modal } from '@components/molecules/modal/Modal';

import {
  StreamItem,
  StreamsBulkAddMenu,
} from 'app/bulk-actions/components/StreamsBulkAddMenu';
import { UiaBulkActionsTrackingIds } from 'app/bulk-actions/uia-bulk-actions/uiaBulkActionsTrackingIds';
import { MANAGE_COLLECTIONS_PERMISSION } from 'app/collections/constants/CollectionsConstants';

interface BulkActionsAddToStreamModalProps {
  isSubmitting?: boolean;
  onCancel: () => void;
  onComplete: (collectionIds: string[]) => void;
}

export const BulkActionsAddToStreamModal = ({
  isSubmitting = false,
  onCancel,
  onComplete,
}: BulkActionsAddToStreamModalProps) => {
  const [selectedStreamIds, setSelectedStreamIds] = useState<
    Record<string, boolean>
  >({});

  const handleSelectStream = (stream: StreamItem) => {
    setSelectedStreamIds((prev) => ({
      ...prev,
      [stream.id]: !prev[stream.id],
    }));
  };

  const handleSubmit = () => {
    const collectionIds = Object.keys(selectedStreamIds).filter(
      (id) => selectedStreamIds[id],
    );
    onComplete(collectionIds);
  };

  const hasSelection = Object.values(selectedStreamIds).some(Boolean);

  return (
    <Modal
      closeModal={onCancel}
      contents={
        <StreamsBulkAddMenu
          onSelectStream={handleSelectStream}
          selectedStreamIds={selectedStreamIds}
        />
      }
      isModalOpen={true}
      primaryButtonInfo={{
        buttonContent: 'Add To Stream',
        buttonStyles: SecondaryButtonStyles,
        isDisabled: !hasSelection || isSubmitting,
        onClick: handleSubmit,
        permissionName: MANAGE_COLLECTIONS_PERMISSION,
        trackingId: UiaBulkActionsTrackingIds.ADD_TO_STREAM_MODAL_SUBMIT,
      }}
      secondaryButtonInfo={{
        buttonContent: 'Cancel',
        onClick: onCancel,
        trackingId: UiaBulkActionsTrackingIds.ADD_TO_STREAM_MODAL_CANCEL,
      }}
      title='Add To Stream'
    />
  );
};
